import { StyleSheet } from 'react-native';

export const createStyles = (isWide: boolean) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    // ── Header ────────────────────────────────────────────────────────────────
    header: {
      position: 'sticky' as any,
      top: 0,
      zIndex: 100,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: isWide ? 48 : 20,
      paddingVertical: 14,
      borderBottomWidth: 1,
    },
    headerLogoContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    headerLogoIcon: {
      width: 28,
      height: 28,
      borderRadius: 6,
    },
    headerLogo: {
      fontSize: 22,
      fontWeight: '800',
    },
    headerActions: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },
    headerThemeToggle: {
      padding: 8,
      borderRadius: 20,
    },
    headerSignIn: {
      paddingHorizontal: 18,
      paddingVertical: 8,
      borderRadius: 20,
      borderWidth: 1.5,
    },
    headerSignInText: {
      fontSize: 14,
      fontWeight: '600',
    },
    // ── Section wrapper ───────────────────────────────────────────────────────
    section: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingVertical: isWide ? 72 : 48,
    },
    sectionTitle: {
      fontSize: isWide ? 32 : 24,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 40,
    },
    // ── Hero ──────────────────────────────────────────────────────────────────
    heroSection: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingTop: isWide ? 96 : 56,
      paddingBottom: isWide ? 80 : 48,
      alignItems: 'center',
    },
    heroTitle: {
      fontSize: isWide ? 56 : 36,
      fontWeight: '900',
      textAlign: 'center',
      lineHeight: isWide ? 64 : 44,
      marginBottom: 20,
    },
    heroTitleAccent: {
      fontSize: isWide ? 56 : 36,
      fontWeight: '900',
    },
    heroTagline: {
      fontSize: isWide ? 20 : 16,
      textAlign: 'center',
      lineHeight: isWide ? 30 : 24,
      marginBottom: 40,
      maxWidth: 560,
    },
    heroButtons: {
      flexDirection: isWide ? 'row' : 'column',
      gap: 12,
      alignItems: 'center',
    },
    heroPrimaryBtn: {
      paddingHorizontal: 32,
      paddingVertical: 16,
      borderRadius: 12,
      minWidth: 200,
      alignItems: 'center',
    },
    heroPrimaryBtnText: {
      fontSize: 16,
      fontWeight: '700',
    },
    heroSecondaryBtn: {
      paddingHorizontal: 32,
      paddingVertical: 16,
      borderRadius: 12,
      borderWidth: 1.5,
      minWidth: 200,
      alignItems: 'center',
    },
    heroSecondaryBtnText: {
      fontSize: 16,
      fontWeight: '600',
    },
    // ── App store badges ──────────────────────────────────────────────────────
    appStoreRow: {
      marginTop: 32,
      alignItems: 'center',
      gap: 12,
    },
    appStoreLabel: {
      fontSize: 13,
    },
    appStoreBadges: {
      flexDirection: 'row',
      gap: 12,
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    appStoreBadge: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 10,
    },
    appStoreBadgeTop: {
      fontSize: 13,
      fontWeight: '600',
    },
    // ── Features ──────────────────────────────────────────────────────────────
    featuresGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 16,
      justifyContent: 'center',
    },
    featureCard: {
      width: isWide ? '30%' : '100%',
      borderRadius: 16,
      borderWidth: 1,
      padding: 24,
    },
    featureIcon: {
      width: 48,
      height: 48,
      borderRadius: 12,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 16,
    },
    featureTitle: {
      fontSize: 17,
      fontWeight: '700',
      marginBottom: 8,
    },
    featureDesc: {
      fontSize: 14,
      lineHeight: 22,
    },
    // ── Screenshots ───────────────────────────────────────────────────────────
    screenshotsGroup: {
      marginBottom: 48,
    },
    screenshotsGroupTitle: {
      fontSize: isWide ? 20 : 16,
      fontWeight: '600',
      textAlign: 'center',
      marginBottom: 24,
      opacity: 0.7,
    },
    screenshotsRow: {
      flexDirection: isWide ? 'row' : 'column',
      gap: 32,
      justifyContent: 'center',
      alignItems: isWide ? 'flex-start' : 'center',
    },
    screenshotCard: {
      alignItems: 'center',
      width: isWide ? 220 : 280,
    },
    phoneFrame: {
      width: isWide ? 220 : 280,
      height: isWide ? 391 : 498,
      borderRadius: 32,
      borderWidth: 3,
      overflow: 'hidden',
    },
    phoneFrameHovered: {
      // web-only shadow via boxShadow would need style injection;
      // border color change (set inline) is enough
      opacity: 0.95,
    } as any,
    screenshotBadge: {
      position: 'absolute',
      top: 14,
      right: 14,
      width: 10,
      height: 10,
      borderRadius: 5,
    },
    screenshotCaption: {
      marginTop: 14,
      paddingHorizontal: 4,
      alignItems: 'center',
    },
    screenshotCaptionTitle: {
      fontSize: 15,
      fontWeight: '700',
      textAlign: 'center',
      marginBottom: 4,
    },
    screenshotCaptionDesc: {
      fontSize: 13,
      lineHeight: 19,
      textAlign: 'center',
    },
    phoneLabel: {
      fontSize: 13,
      fontWeight: '600',
      marginTop: 8,
      textAlign: 'center',
    },
    // ── Lightbox ──────────────────────────────────────────────────────────────
    lightboxOverlay: {
      position: 'fixed' as any,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.88)',
      zIndex: 1000,
      justifyContent: 'center',
      alignItems: 'center',
    },
    lightboxContent: {
      alignItems: 'center',
      maxWidth: 380,
      width: '90%' as any,
    },
    lightboxClose: {
      alignSelf: 'flex-end',
      padding: 8,
      marginBottom: 16,
    },
    lightboxPhone: {
      width: 320,
      height: 568,
      borderRadius: 40,
      borderWidth: 3,
      overflow: 'hidden',
    },
    lightboxCaption: {
      marginTop: 20,
      alignItems: 'center',
      paddingHorizontal: 8,
    },
    lightboxTitle: {
      fontSize: 18,
      fontWeight: '700',
      color: '#ffffff',
      textAlign: 'center',
      marginBottom: 6,
    },
    lightboxDesc: {
      fontSize: 14,
      lineHeight: 21,
      color: 'rgba(255,255,255,0.7)',
      textAlign: 'center',
    },
    // ── Pricing ───────────────────────────────────────────────────────────────
    pricingRow: {
      flexDirection: isWide ? 'row' : 'column',
      gap: 20,
      justifyContent: 'center',
    },
    pricingCard: {
      flex: isWide ? 1 : undefined,
      maxWidth: isWide ? 400 : undefined,
      borderRadius: 20,
      borderWidth: 2,
      padding: 28,
    },
    pricingPlanName: {
      fontSize: 22,
      fontWeight: '800',
      marginBottom: 4,
    },
    pricingPrice: {
      fontSize: 36,
      fontWeight: '900',
      marginBottom: 4,
    },
    pricingPriceSub: {
      fontSize: 13,
      marginBottom: 20,
    },
    pricingRow2: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingVertical: 10,
      borderBottomWidth: 1,
    },
    pricingFeatureText: {
      fontSize: 14,
    },
    pricingValueText: {
      fontSize: 14,
      fontWeight: '600',
    },
    pricingBtn: {
      marginTop: 24,
      paddingVertical: 14,
      borderRadius: 12,
      alignItems: 'center',
    },
    pricingBtnText: {
      fontSize: 15,
      fontWeight: '700',
    },
    // ── Footer ────────────────────────────────────────────────────────────────
    footerSection: {
      paddingHorizontal: isWide ? 80 : 24,
      paddingVertical: isWide ? 64 : 48,
      alignItems: 'center',
    },
    footerCta: {
      fontSize: isWide ? 36 : 26,
      fontWeight: '800',
      textAlign: 'center',
      marginBottom: 32,
    },
    footerLinks: {
      flexDirection: 'row',
      gap: 24,
      marginTop: 40,
    },
    footerLink: {
      fontSize: 13,
    },
    footerCopyrightRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      marginTop: 16,
    },
    footerLogoIcon: {
      width: 14,
      height: 14,
      borderRadius: 3,
      opacity: 0.5,
    },
    footerCopyright: {
      fontSize: 12,
    },
    // ── Blog / What's New ─────────────────────────────────────────────────────
    blogGrid: {
      gap: 20,
    },
    blogCard: {
      borderRadius: 16,
      borderWidth: 1,
      padding: 24,
    },
    blogCardTags: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
      marginBottom: 10,
    },
    blogCardTag: {
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 20,
      borderWidth: 1,
    },
    blogCardTagText: {
      fontSize: 11,
      fontWeight: '600',
    },
    blogCardTitle: {
      fontSize: isWide ? 18 : 16,
      fontWeight: '700',
      marginBottom: 6,
      lineHeight: 24,
    },
    blogCardDate: {
      fontSize: 12,
      marginBottom: 8,
    },
    blogCardSummary: {
      fontSize: 14,
      lineHeight: 21,
      marginBottom: 14,
    },
    blogCardReadMore: {
      fontSize: 13,
      fontWeight: '600',
    },
    blogViewAll: {
      marginTop: 28,
      alignItems: 'center' as const,
    },
    blogViewAllText: {
      fontSize: 15,
      fontWeight: '600',
    },
  });
